import * as api from '../api';

// onActivate: callback or array of callbacks to retrieve async data (returns data to be merged)
// data_keys: keys to be saved when moving from a child to a parent

/*
 click tab:
 {intersection: "profile.focus", toDeactivate: ["profile.focus.show_entity"], toActivate: ["profile.focus.edit_entity"]}

on edit
 [Log] transition:  – {intersection: "profile.focus", toDeactivate: ["profile.focus.show_entity"], toActivate: ["profile.focus.edit_entity"]} (main.chunk.js, line 10601)

 */

import contact_routes from './contact_routes';
import entity_routes from './entity_routes';

const routes = [
    { name: 'login',
      path: '/login',
      onActivate: [{
	k: 'cgu',
	cb: () => api.getAppConfigJsonValue("cgu").then(d => ({cgu: d}))
      }]
    },
    { name: 'logout', path: '/logout' },
    { name: 'pin', path: '/pin' },
    { name: 'setPin', path: '/setPin' },
    {
        name: "postfeed",
        path: '/',
        title: "Accueil",
        onActivate: [{
            k:"bookmarks",
            cb: () => api.getBookmark().then(d => ({ bookmarks: d })),
        }, {
          k: 'geos',
          cb: () => api.getAllGeo().then(d => ({ geos: d }))
        /*
        }, {
          k: 'contacts',
          cb: () => api.getAllContact().then(d => ({ contacts: d.data })),
        }, {
          k: 'entities',
          cb: () => api.getAllEntity().then(d => ({ entities: d.data })),
        */
        }, {
            k:'users',
            cb:()=> api.getAllUser().then(d => ({users:d.data}))
        }, {
          k:'map_settings_post_geo',
          cb: () => api.getAppConfigJsonValue("map_settings_post_geo").then(d => ({map_settings_post_geo: d}))
        }]
    },
    {
        name: "postfeed.post",
        path: '/post/:id',
        title: "Content",
        onActivate: (toState) => api.getPost(toState.params.id).then(d => ({ post: d}))
    },

    {
        name: "post",
        title: "Content",
        path: '/post/:id',
        onActivate:[{
            k:"feed",
            cb:  (toState)=>api.getPost(toState.params.id).then(d =>({post: d}))
            },
            {
                k:"users",
                cb: ()=> api.getAllUser().then(d2=>({ users : d2.data}))
            }]
    },
    {
        name: "contributor",
        path: '/contributor/:id',
        title: "Contributeur",
        onActivate:[{
            k:"user",
            cb:  (toState)=>api.getProfil(toState.params.id).then(d =>({user: d}))
        },{
            k:"bookmarks",
            cb: () => api.getBookmark().then(d => ({ bookmarks: d })),
        },{
            k:'users',
            cb:()=> api.getAllUser().then(d => ({users:d.data}))
        }]
    },
    {
      name: 'profile',
      path: '/profile',
      title: "My profile",
      onActivate: [{
          k:"profile",
          cb:() => () => api.getMyProfil().then(d => ({ profil: d.data })),
      },{
          k:"bookmarks",
          cb: () => api.getBookmark().then(d => ({ bookmarks: d })),
      },{
          k:'users',
          cb:()=> api.getAllUser().then(d => ({users:d.data}))
      }]
    },
    {
      name: "profile.bookmark",
      path: '/bookmark',
      title: "My profile",
      onActivate: [{
          k:"profil",
          cb:() => () => api.getMyProfil().then(d => ({ profil: d.data })),
      },{
          k:"bookmarks",
          cb: () => api.getBookmark().then(d => ({ bookmarks: d })),
      }]
    },
    {
      name: "profile.focus",
      path: '/focus',
      title: "My profile",
      onActivate: [{
          k: 'focus_contact',
          cb: () => api.getFocusContact().then(d => ({ focus_contact: d })),
        }, {
          k: 'focus_entity',
          cb: () => api.getFocusEntity().then(d => ({ focus_entity: d })),
        }, {
          k: 'focus_theme',
          cb: () => api.getFocusTheme().then(d => ({ focus_theme: d })),
        }, {
          k: 'contacts',
          cb: () => api.getAllContact().then(d => ({ contacts: d.data })),
        }, {
          k: 'entities',
          cb: () => api.getAllEntity().then(d => ({ entities: d.data })),
        }, {
          k: 'themes',
          cb: () => api.getAllTheme().then(d => ({ themes: d })),
      },{
          k:"profil",
          cb:() => () => api.getMyProfil().then(d => ({ profil: d.data })),
      },{
          k:"bookmarks",
          cb: () => api.getBookmark().then(d => ({ bookmarks: d })),
      }]
    },

    // focus show
    {
      name: "profile.focus.show_contact",
      path: '/show/contact',
      title: "My profile",
    },
    {
      name: "profile.focus.show_entity",
      path: '/show/entity',
      title: "My profile",
    },
    {
      name: "profile.focus.show_theme",
      path: '/show/theme',
      title: "My profile",
    },

    // focus edit
    {
      name: "profile.focus.edit_contact",
      path: '/edit/contact',
      title: "My profile",
    },
    {
      name: "profile.focus.edit_entity",
      path: '/edit/entity',
      title: "My profile",
    },
    {
      name: "profile.focus.edit_theme",
      path: '/edit/theme',
      title: "My profile",
    },

    // GRID
    {
      name: "grid",
      path: '/grid/:id',
      title: "Grid",
      back_route: ({ grid }) => ({name: "explore.theme", params: {id: grid.theme_id}}),
      onActivate: [{
        k: "grid",
        cb: (toState) => api.getGrid(toState.params.id).then(d => ({ grid: d}))
        }, {
          k: 'theme',
          cb: (toState) => api.getTheme(toState.params.id).then(d => ({ theme: d}))
	}, {
          k: 'contacts',
          cb: () => api.getAllContact().then(d => ({ contacts: d.data })),
        }, {
          k: 'entities',
          cb: () => api.getAllEntity().then(d => ({ entities: d.data })),
	}, {
          k: 'active_users',
          cb: () => api.getAllUser().then(d => ({active_users: d.data.filter(x => x.is_active)}))
      }]
    },
    {
      name: "grid.contact",
      path: '/contact/:contact_id',
      title: "Grid",
    },
    {
      name: "grid.entity",
      path: '/entity/:entity_id',
      title: "Grid",
    },
    {
      name: "grid.edit",
      back_route: ({ grid }) => ({name: "explore.theme", params: {id: grid.theme_id}}),
      path: '/edit',
      title: "Grid update"
    },
    {
      name: "grid.edit.contact",
      path: '/contact/:contact_id',
      title: "Grid update",
    },
    {
      name: "grid.edit.entity",
      path: '/entity/:entity_id',
      title: "Grid update",
    },
    // CARTO
    {
      name: "carto",
      path: '/carto',
      title: "Cartography",
      onActivate: [{
          k: 'links',
          cb: () => api.getLinks().then(d => ({ links: d.data })),
        }, {
          k: 'contacts',
          cb: () => api.getAllContact().then(d => ({ contacts: d.data })),
        }, {
          k: 'entities',
          cb: () => api.getAllEntity().then(d => ({ entities: d.data })),
        }, {
          k: 'themes',
          cb: () => api.getAllTheme().then(d => ({ themes: d })),
        }, {
          k: 'geos',
          cb: () => api.getAllGeo().then(d => ({ geos: d }))
        // Why feed?!
        }, {
          k: "feed",
          cb: () => api.getFeedNormal().then(d => ({ post_list: d.data, cursor: d.cursor })),
        },{
          k: 'users',
          cb: () => api.getAllUser().then(d => ({users:d.data}))
        }, {
          k:'map_settings_contact_entity_network',
          cb: () => api.getAppConfigJsonValue("map_settings_contact_entity_network").then(d => {
            return {map_settings_contact_entity_network: d}
          })
        }, {
          k:'map_settings_contact_entity_geo',
          cb: () => api.getAppConfigJsonValue("map_settings_contact_entity_geo").then(d => {
            return {map_settings_contact_entity_geo: d}
          })
      }].concat(
        // used by carto link for profile/contact
        [{
            k:"bookmarks",
            cb: () => api.getBookmark().then(d => ({ bookmarks: d }))
        }, {
          k: 'focus_contact',
          cb: () => api.getFocusContact().then(d => ({ focus_contact: d })),
        }, {
          k: 'focus_entity',
          cb: () => api.getFocusEntity().then(d => ({ focus_entity: d })),
        },{
            k:"trending",
            cb: () => api.getTrendingAll(7).then(d => ({ trending: d}))
        },{
          k: 'affiliations',
          cb: () => api.getAffiliations().then(d => ({affiliations:d.data}))
        }]
      )
    },

    // carto link
    {
      name: "carto.link",
      path: '/link',
      title: "Cartography"
    },
    {
      name: "carto.link.entity",
      path: '/entity/:id',
      title: "Cartography",
      onActivate: [{
        k:"entity",
        cb: (toState) => api.getEntity(toState.params.id).then(d => ({ entity: d}))
      }]
    },
    {
      name: "carto.link.contact",
      path: '/contact/:id',
      title: "Cartography",
      onActivate: [{
        k:"contact",
        cb: (toState) => api.getContact(toState.params.id).then(d => ({ contact: d}))
      }]
    },


    // carto geo (same as carto.link)
    {
      name: "carto.geo",
      path: '/geo',
      title: "Cartography",
    },
    {
      name: "carto.geo.entity",
      path: '/entity/:id',
      title: "Cartographie",
      onActivate: [{
        k:"entity",
        cb: (toState) => api.getEntity(toState.params.id).then(d => ({ entity: d}))
      }]
    },
    {
      name: "carto.geo.contact",
      path: '/contact/:id',
      title: "Cartography",
      onActivate: [{
        k:"contact",
        cb: (toState) => api.getContact(toState.params.id).then(d => ({ contact: d}))
      }]
    },

    {
      name: "carto.geo.agg",
      path: '/agg',
      title: "Cartography",
    },
    {
      name: "carto.geo.agg.contacts",
      path: '/contacts',
      title: "Cartography",
    },
    {
      name: "carto.geo.agg.entities",
      path: '/entities',
      title: "Cartography",
    },

    // explore
    {
      name: "explore",
      path: '/explore',
      title: "Explore",
      onActivate: [{
            k:"feed",
            cb:() => api.getFeedNormal().then(d => ({ post_list: d.data, cursor:d.cursor}))
      },
        {
          k:"bookmarks",
          cb: () => api.getBookmark().then(d => ({ bookmarks: d })),
        },{
          k:'users',
          cb:()=> api.getAllUser().then(d => ({users:d.data}))
      }].concat([{
          k: 'links',
          cb: () => api.getLinks().then(d => ({ links: d.data })),
        }, {
          k: 'contacts',
          cb: () => api.getAllContact().then(d => ({ contacts: d.data })),
        }, {
          k: 'entities',
          cb: () => api.getAllEntity().then(d => ({ entities: d.data })),
        },{
          k:"trending",
          cb: () => api.getTrendingAll(7).then(d => ({ trending: d}))
      }])
    },
    {
      name: "explore.contacts",
      path: '/contact',
      title: "Explore",
    },
    {
      name: "explore.contact",
      path: '/contact/:id',
      title: "Explore",
      onActivate: [{
          k:"contact",
          cb: (toState) => api.getContact(toState.params.id).then(d => ({ contact: d}))
      },{
          k:"bookmarks",
          cb: () => api.getBookmark().then(d => ({ bookmarks: d }))
      }, {
        k: 'focus_contact',
        cb: () => api.getFocusContact().then(d => ({ focus_contact: d })),

      },{
          k:'users',
          cb:()=> api.getAllUser().then(d => ({users:d.data}))
          // for carto.link
      }].concat([{
          k: 'links',
          cb: () => api.getLinks().then(d => ({ links: d.data })),
        }, {
          k: 'contacts',
          cb: () => api.getAllContact().then(d => ({ contacts: d.data })),
        }, {
          k: 'entities',
          cb: () => api.getAllEntity().then(d => ({ entities: d.data })),
        },{
            k:"trending",
            cb: () => api.getTrendingAll(7).then(d => ({ trending: d}))
        },{
          k: 'affiliations',
          cb: () => api.getAffiliations().then(d => ({affiliations:d.data}))
        }, {
          k:'map_settings_contact_entity_network',
          cb: () => api.getAppConfigJsonValue("map_settings_contact_entity_network").then(d => {
	    return {map_settings_contact_entity_network: d}
	  })
        }])
    },
    {
      name: "explore.entities",
      path: '/entity',
      title: "Explore",
    },
    {
      name: "explore.entity",
      path: '/entity/:id',
      title: "Explore",
      onActivate: [{
          k:"entity",
          cb: (toState) => api.getEntity(toState.params.id).then(d => ({ entity: d}))
      },{
          k:"bookmarks",
          cb: () => api.getBookmark().then(d => ({ bookmarks: d }))
      }, {
        k: 'focus_entity',
        cb: () => api.getFocusEntity().then(d => ({ focus_entity: d })),
      },{
        k:'users',
        cb:()=> api.getAllUser().then(d => ({users:d.data}))
      // for carto.link
      }].concat([{
          k: 'links',
          cb: () => api.getLinks().then(d => ({ links: d.data })),
        }, {
          k: 'contacts',
          cb: () => api.getAllContact().then(d => ({ contacts: d.data })),
        }, {
          k: 'entities',
          cb: () => api.getAllEntity().then(d => ({ entities: d.data })),
        },{
          k:"trending",
          cb: () => api.getTrendingAll(7).then(d => ({ trending: d}))
        },{
          k: 'affiliations',
          cb: () => api.getAffiliations().then(d => ({affiliations:d.data}))
        }, {
          k:'map_settings_contact_entity_network',
          cb: () => api.getAppConfigJsonValue("map_settings_contact_entity_network").then(d => {
	    return {map_settings_contact_entity_network: d}
	  })
      }])
    },
    {
      name: "explore.themes",
      path: '/theme',
      title: "Explore",
      data_keys: ['themes_list'],
      onActivate: [{
          k: 'focus_theme',
          cb: () => api.getFocusTheme().then(d => ({ focus_theme: d })),
        }, {
          k: 'themes',
          cb: () => api.getAllTheme().then(d => ({ themes: d })),
      }]
    },
    {
      name: "explore.theme",
      path: '/theme/:id',
      title: "Explore",
      onActivate: [{
          k:"theme",
          cb: (toState) => api.getTheme(toState.params.id).then(d => ({ theme: d}))
      },{
          k:"bookmarks",
          cb: () => api.getBookmark().then(d => ({ bookmarks: d }))
      },{
        k: 'themes',
        cb: () => api.getAllTheme().then(d => ({ themes: d })),
      },{
        k: 'focus_theme',
        cb: () => api.getFocusTheme().then(d => ({ focus_theme: d })),
      },{
          k:'users',
          cb: () => api.getAllUser().then(d => {
	    return {
	      users: d.data,
	      active_users: d.data.filter(x => x.is_active)
	    }
	  })
      },{
        k: "grid",
        cb: (toState) => api.getGrid(toState.params.id).then(d => ({ grid: d}))
      }, {
	k: "custom_map",
        cb: (toState) => api.getCustomMap(toState.params.id).then(d => ({ custom_map: d}))
      }]
    },
    {
      name: "explore.theme.briefing",
      path: '/briefing',
      title: "Explore",
      onActivate: () => api.getBookmark().then(d => ({ bookmarks: d }))
    },
    {
      title: "Explore",
      name: "explore.theme.briefing.contact",
      path: '/contact/:contact_id',
    }, {
      title: "Explore",
      name: "explore.theme.briefing.entity",
      path: '/entity/:entity_id',
    },
    {
      name: "explore.theme.reseaux",
      path: '/reseaux',
      title: "Explore",
    },
    {
      name: "explore.theme.entities",
      path: '/entities',
      title: "Explore",
    },
    {
      name: "explore.theme.arborescense",
      path: '/themes',
      title: "Explore",
      onActivate: () => api.getFocusTheme().then(d => ({ focus_theme: d })),
    },
    {
      name: "explore.theme.participants",
      path: '/participants',
      title: "Explore",
    },
    {
      name: "explore.theme.custom_map",
      path: '/custom_map',
      title: "Explore",
    },
    // should be by contact...
    {
      name: "explore.theme.custom_map.node",
      path: '/node/:node_id',
      title: "Explore",
    },
    {
      name: "explore.theme.custom_map.entity",
      path: '/node/:node_id/entity/:entity_id',
      title: "Cartography",
      onActivate: [{
        k:"entity",
        cb: (toState) => api.getEntity(toState.params.entity_id).then(d => ({ entity: d}))
      }]
    },
    {
      name: "explore.theme.custom_map.contact",
      path: '/node/:node_id/contact/:contact_id',
      title: "Cartography",
      onActivate: [{
        k:"contact",
        cb: (toState) => api.getContact(toState.params.contact_id).then(d => ({ contact: d}))
      }]
    },
    {
      name: "explore.content",
      path: '/content',
      title: "Explore",
      onActivate: [{
          k:"feed",
          cb:() => api.getFeedNormal().then(d => ({ post_list: d.data, cursor:d.cursor}))
      },{
          k:"bookmarks",
          cb: () => api.getBookmark().then(d => ({ bookmarks: d })),
      },{
          k:'users',
          cb:()=> api.getAllUser().then(d => ({users:d.data}))
      }]
    },
    {
      name: "trending",
      path: '/trending',
      title: "Trending",
      onActivate: [{
          k:"bookmarks",
          cb: () => api.getBookmark().then(d => ({ bookmarks: d })),
      },{
          k:'users',
          cb:()=> api.getAllUser().then(d => ({users:d.data}))
      }]
    },

    {
      name: "settings",
      path: '/settings',
      title: "Settings",
      onActivate: [{
	k: 'cgu',
        cb: () => api.getAppConfigJsonValue("cgu").then(d => ({cgu: d}))
      }]
    },
    {
        name: "settings.apparence",
        path: '/apparence',
        title: "Settings"
    },
    {
        name: "settings.privacy",
        path: '/privacy',
        title: "Settings"
    },
    {
        name: "settings.langue",
        path: '/langue',
        title: "Settings"
    },
    {
        name: "settings.cgu",
        path: '/cgu',
        title: "Settings"
    },
    {
        name: "settings.notification",
        path: '/notification',
        title: "Settings"
    },
    {
        name: "settings.app_update",
        path: '/app_update',
        title: "Settings"
    },

    {
      name: "editor",
      path: '/editor',
      title: "Write content",
      onActivate: [{
          k: 'contacts',
          cb: () => api.getAllContact().then(d => ({ contacts: d.data })),
      },{
          k: 'entities',
          cb: () => api.getAllEntity().then(d => ({ entities: d.data })),
      },{
          k: 'themes',
          cb: () => api.getAllTheme().then(d => ({ themes: d })),
      },{
          k: 'geo',
          cb: () => api.getAllGeo().then(d => ({ geo: d}))
      }]
    },
    {
        name: "IM",
        path: '/IM',
        title: "Messages"
    },
].concat(contact_routes, entity_routes);


// TODO: add alias behaviour?
// ensure all routes have a properly defined onActivate method
function normalize(routes) {
  return routes.map(route => {
    let cb = route.onActivate;

    if (cb === undefined) return {...route, onActivate: []};

    cb = (typeof cb === 'function') ? [cb] : cb;

    const onActivate = cb.map((v, i) => {
      if (typeof v === 'function') return {k: 'default_' + i, cb: v };
      return v;
    })

    return {...route, onActivate};
  })
}

export default normalize(routes);
